import React, { FC, useContext, useMemo } from "react";
import {
  CustomPropertyKeys,
  TranslationKeys,
} from "../../../infrastructure/const";
import CheckUtils from "../../../utilities/check-utils";
import CartCouponCode from "../cart-coupon-code";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";

interface Props {
  properties: Record<string, any>;
  onUpdate: (value: string) => void;
}

const EanNumber: FC<Props> = ({ properties, onUpdate }): JSX.Element => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const eanNumberValue = useMemo(
    () => properties[CustomPropertyKeys.DK.EANNumber],
    [properties]
  );

  const eanNumberSelected = useMemo(
    () =>
      !CheckUtils.isNullObject(properties) &&
      !CheckUtils.isNullOrEmptyString(eanNumberValue),
    [eanNumberValue, properties]
  );

  const eanNumberApplied =
    !CheckUtils.isNullObject(properties) &&
    eanNumberSelected &&
    !CheckUtils.isNullOrEmptyString(eanNumberValue);

  return (
    <CartCouponCode
      onValueChange={onUpdate}
      id="ean"
      selected={eanNumberSelected}
      value={eanNumberValue}
      applied={eanNumberApplied}
      label={translationManager.getTranslation(
        TranslationKeys.DK.EAN_NUMBER_LABEL
      )}
      placeholder={translationManager.getTranslation(
        TranslationKeys.DK.EAN_NUMBER_PLACEHOLDER
      )}
      buttonApplyLabel={translationManager.getTranslation(TranslationKeys.APPLY)}
      buttonCancelLabel={translationManager.getTranslation(TranslationKeys.CANCEL)}
      displayResponseMessage={false}
      responseMessage=""
      isErrorMessage={false}
      isMandatory={false}
    />
  );
};

export default EanNumber;
